<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
          <div class="col-md-12">
              <div class="top-list-small-toolbar">
                  <div>
                      <h4 class="text-primary">Set Journal All transaction</h4>
                      <div class="form-inline">
                        <span><b>Company:</b></span>
                        <select v-model="company_no" class="form-control">
                          <option value="">-- All --</option>
                          <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                        </select>
                        <span><b>Date:</b></span>
                        <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                        <button type="button" class="btn btn-sm btn-hard-primary waves-light waves-effect" @click="refreshList">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                        </button>
                        <button type="button" class="btn btn-sm btn-soft-primary" @click="setAll">
                          <i class="fa fa-refresh" aria-hidden="true"></i> Set All
                        </button>
                        <button type="button" class="btn btn-sm btn-soft-danger" @click="deleteAll">
                          <i class="fa fa-trash" aria-hidden="true"></i> Delete Journal
                        </button>
                      </div>
                  </div>
              </div>
            </div>
      </div>
      <div class="row" style="margin-top: 150px">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <ul class="nav nav-tabs nav-bordered">
                <li class="nav-item"><a href="#data-sort" data-toggle="tab" aria-expanded="false" class="nav-link active">Data Sort</a></li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane active" id="data-sort">
                  <h5>Purchasing</h5>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="getPurchasing">Get Purchasing</button>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="setPurchasing">Set Journal</button>
                  <button type="button" class="btn btn-sm btn-soft-danger" @click="deletePurchasing">Delete</button>
                  <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                      <thead>
                        <th>#</th>
                        <th>Purchasing No</th>
                        <th>Date</th>
                        <th>Vendor</th>
                        <th>Subtotal</th>
                        <th>Discount</th>
                        <th>Tax</th>
                        <th>Delivery Cost</th>
                        <th>Total</th>
                        <th>Journal Persediaan</th>
                        <th>Journal Hutang</th>
                        <th>Journal Delivery</th>
                      </thead>
                      <tbody>
                        <tr v-for="p in purchasing" :key="p.id">
                          <td>
                            <label class="form-checkbox"><input type="checkbox" :value="p.id" v-model="selectedPurchase"><i class="form-icon"></i></label>
                          </td>
                          <td>{{ p.purchasing_no }}</td>
                          <td>{{ p.purchasing_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td>{{ p.vendor }}</td>
                          <td>{{ p.subtotal | currency }}</td>
                          <td>{{ p.discount | currency }}</td>
                          <td>{{ p.tax | currency }}</td>
                          <td>{{ p.delivery_cost | currency }}</td>
                          <td>{{ p.total }}</td>
                          <td>{{ p.total_persediaan | currency }}</td>
                          <td>{{ p.total_hutang | currency }}</td>
                          <td>{{ p.total_delivery | currency }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <hr>
                  <h5>Sales</h5>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="getSales">Get Sales</button>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="setSales">Set Journal</button>
                  <button type="button" class="btn btn-sm btn-soft-danger" @click="deleteSales">Delete</button>
                  <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                      <thead>
                        <th>#</th>
                        <th>Sales No.</th>
                        <th>Date</th>
                        <th>Customer</th>
                        <th>Total</th>
                        <th>Journal</th>
                      </thead>
                      <tbody>
                        <tr v-for="s in sales" :key="s.id">
                          <td><label class="form-checkbox"><input type="checkbox" :value="s.id" v-model="selectedSales"><i class="form-icon"></i></label></td>
                          <td>{{ s.sale_no }}</td>
                          <td>{{ s.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td>{{ s.customer_name }}</td>
                          <td>{{ s.total | currency }}</td>
                          <td>{{ s.journal_count }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <h5>Manufacture</h5>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="getManufacture">Get Manufacture</button>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="setManufacture">Set Journal</button>
                  <button type="button" class="btn btn-sm btn-soft-danger" @click="deleteManufacture">Delete</button>
                  <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                      <thead>
                        <th>#</th>
                        <th>Manufacture No.</th>
                        <th>Date</th>
                        <th>Finish Date</th>
                        <th>Customer</th>
                        <th>Total</th>
                        <th>Journal</th>
                      </thead>
                      <tbody>
                        <tr v-for="m in manufacture" :key="m.id">
                          <td><label class="form-checkbox"><input type="checkbox" :value="m.id" v-model="selectedManufacture"><i class="form-icon"></i></label></td>
                          <td>{{ m.manufacture_no }}</td>
                          <td>{{ m.manufacture_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td>{{ m.manufacture_finish_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td>{{ m.customer }}</td>
                          <td>{{ m.total_product | currency }}</td>
                          <td>{{ m.total_journal | currency }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <h5>Payment</h5>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="getPayment">Get Payment</button>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="setPayment">Set Journal</button>
                  <button type="button" class="btn btn-sm btn-soft-danger" @click="deletePayment">Delete</button>
                  <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                      <thead>
                        <th>#</th>
                        <th>Status</th>
                        <th>Category</th>
                        <th>Payment No.</th>
                        <th>Payment Date</th>
                        <th>Finish Date</th>
                        <th>Method</th>
                        <th>Subtotal</th>
                        <th>Round</th>
                        <th>Discount</th>
                        <th>UM</th>
                        <th>Total</th>
                        <th>Journal</th>
                      </thead>
                      <tbody>
                        <tr v-for="p in payment" :key="p.id">
                          <td><label class="form-checkbox"><input type="checkbox" :value="p.id" v-model="selectedPayment"><i class="form-icon"></i></label></td>
                          <td>{{ p.status }}</td>
                          <td>{{ p.category }}</td>
                          <td>{{ p.group_no }}</td>
                          <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td>{{ p.finish_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td>{{ p.method }}</td>
                          <td>{{ p.subtotal | currency }}</td>
                          <td>{{ p.round | currency }}</td>
                          <td>{{ p.discount | currency }}</td>
                          <td>{{ p.total_um | currency }}</td>
                          <td>{{ p.total | currency }}</td>
                          <td>{{ p.journal_count }}</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>{{ totalPaymentSales | currency }}</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <h5>Adjust</h5>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="getAdjust">Get Adjust</button>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="setAdjust">Set Journal</button>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="deleteAdjust">Delete</button>
                  <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                      <thead>
                        <th>#</th>
                        <th>Inventory No.</th>
                        <th>Type</th>
                        <th>Total</th>
                        <th>Journal</th>
                      </thead>
                      <tbody>
                        <tr v-for="a in adjust" :key="a.id">
                          <td><label class="form-checkbox"><input type="checkbox" :value="a.id" v-model="selectedAdjust"><i class="form-icon"></i></label></td>
                          <td>{{ a.inventory_no }}</td>
                          <td>{{ a.type }}</td>
                          <td>{{ a.total_cost | currency }}</td>
                          <td>{{ a.total_journal | currency }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <h5>Convert</h5>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="getConvert">Get Convert</button>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="setConvert">Set Journal</button>
                  <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                      <thead>
                        <th>#</th>
                        <th>Convert No.</th>
                        <th>Date</th>
                        <th>Product</th>
                        <th>Total</th>
                        <th>Journal</th>
                      </thead>
                      <tbody>
                        <tr v-for="c in convert" :key="c.id">
                          <td><label class="form-checkbox"><input type="checkbox" :value="c.id" v-model="selectedConvert"><i class="form-icon"></i></label></td>
                          <td>{{ c.convert_no }}</td>
                          <td>{{ c.convert_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td>{{ c.product_no}} - {{ c.product }}</td>
                          <td>{{ c.total_amount | currency }}</td>
                          <td>{{ c.total_journal | currency }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <h5>Retur</h5>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="getRetur">Get Retur</button>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="setRetur">Set Journal</button>
                  <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                      <thead>
                        <th>#</th>
                        <th>Type</th>
                        <th>Return No.</th>
                        <th>Date</th>
                        <th>Total</th>
                        <th>Journal</th>
                      </thead>
                      <tbody>
                        <tr v-for="r in retur" :key="r.id">
                          <td><label class="form-checkbox"><input type="checkbox" :value="r.id" v-model="selectedRetur"><i class="form-icon"></i></label></td>
                          <td>{{ r.type }}</td>
                          <td>{{ r.return_no }}</td>
                          <td>{{ r.return_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td>{{ r.total | currency }}</td>
                          <td>
                            <span v-if="r.type === 'sales'">{{ r.total_journal | currency }}</span>
                            <span v-else>{{ r.total_journal_persediaan | currency }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <h5>On Hand</h5>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="getOnHand">Get On Hand</button>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="setOnHand">Set Journal</button>
                  <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                      <thead>
                        <th>#</th>
                        <th>Hand no.</th>
                        <th>Date</th>
                        <th>Total Cost</th>
                        <th>Journal</th>
                      </thead>
                      <tbody>
                        <tr v-for="o in onHand" :key="o.id">
                          <td><label class="form-checkbox"><input type="checkbox" :value="o.id" v-model="selectedOnHand"><i class="form-icon"></i></label></td>
                          <td>{{ o.hand_no }}</td>
                          <td>{{ o.hand_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td>{{ o.total_cost | currency }}</td>
                          <td>{{ o.journal_count }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <h5>Kas</h5>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="getCashOnHand">Get Kas</button>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="setCOH">Set Journal</button>
                  <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                      <thead>
                        <th>#</th>
                        <th>Type</th>
                        <th>Cash No.</th>
                        <th>Date</th>
                        <th>Account</th>
                        <th>Total</th>
                        <th>Journal</th>
                      </thead>
                      <tbody>
                        <tr v-for="ch in coh" :key="ch.id">
                          <td><label class="form-checkbox"><input type="checkbox" :value="ch.id" v-model="selectedCoh"><i class="form-icon"></i></label></td>
                          <td>{{ ch.cash_type }}</td>
                          <td>{{ ch.detail_no }}</td>
                          <td>{{ ch.cash_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td>{{ ch.account_code }} - {{ ch.account }}</td>
                          <td>{{ ch.total | currency }}</td>
                          <td>{{ ch.total_journal | currency }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { cohUrl, convertUrl, getHeader, inventoryUrl, journalUrl, manufactureUrl, paymentUrl, purchasingUrl, returnUrl, salesUrl } from '../../config'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'JournalSetAll',
  props: ['scroll'],
  components: {
    Loading,
    DatePicker
  },
  data () {
    const date = new Date()
    return {
      company_no: '',
      startDate: [date, date],
      purchasing: [],
      selectedPurchase: [],
      sales: [],
      selectedSales: [],
      manufacture: [],
      selectedManufacture: [],
      payment: [],
      selectedPayment: [],
      adjust: [],
      selectedAdjust: [],
      convert: [],
      selectedConvert: [],
      retur: [],
      selectedRetur: [],
      onHand: [],
      selectedOnHand: [],
      coh: [],
      selectedCoh: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList
    }),
    totalPaymentSales () {
      var array = this.payment.filter(d => d.category === 'sales')
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    }
  },
  methods: {
    async deleteAdjust () {
      await this.$Progress.start()
      this.loader.isLoading = true
      const array = this.selectedAdjust
      for (let i = 0; i < array.length; i++) {
        const ad = this.ad.find(d => d.id === array[i])
        const body = {
          ref_no: ad.inventory_no
        }
        await axios.post(journalUrl + '/delete-ref-no', body, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Success delete journal adjust', 'success')
      await this.refreshList()
    },
    async deletePayment () {
      await this.$Progress.start()
      this.loader.isLoading = true
      const array = this.selectedPayment
      for (let i = 0; i < array.length; i++) {
        const pay = this.payment.find(d => d.id === array[i])
        const body = {
          ref_no: pay.group_no
        }
        await axios.post(journalUrl + '/delete-ref-no', body, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Success delete journal payment', 'success')
      await this.refreshList()
    },
    async deleteManufacture () {
      await this.$Progress.start()
      this.loader.isLoading = true
      const array = this.selectedManufacture
      for (let i = 0; i < array.length; i++) {
        const mnf = this.manufacture.find(d => d.id === array[i])
        const body = {
          ref_no: mnf.manufacture_no
        }
        await axios.post(journalUrl + '/delete-ref-no', body, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Success delete journal manufacture', 'success')
      await this.refreshList()
    },
    async deleteSales () {
      await this.$Progress.start()
      this.loader.isLoading = true
      const array = this.selectedSales
      for (let i = 0; i < array.length; i++) {
        const sl = this.sales.find(d => d.id === array[i])
        const body = {
          ref_no: sl.sale_no
        }
        console.log(body)
        console.log(journalUrl + '/delete-ref-no')
        await axios.post(journalUrl + '/delete-ref-no', body, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Success delete journal manufacture', 'success')
      await this.refreshList()
    },
    async deletePurchasing () {
      await this.$Progress.start()
      this.loader.isLoading = true
      const array = this.selectedPurchase
      for (let i = 0; i < array.length; i++) {
        const po = this.purchasing.find(d => d.id === array[i])
        const body = {
          ref_no: po.purchasing_no
        }
        console.log(body)
        console.log(journalUrl + '/delete-ref-no')
        await axios.post(journalUrl + '/delete-ref-no', body, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Success delete journal sales', 'success')
      await this.refreshList()
    },
    async deleteAll () {
      await this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      const body = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      console.log(body)
      console.log(journalUrl + '/journal-remove-by-date')
      await axios.post(journalUrl + '/journal-remove-by-date', body, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Success', response.data.message, 'success')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async setAll () {
      await this.setPurchasing()
      await this.setSales()
      await this.setAdjust()
      await this.setManufacture()
      await this.setCOH()
      await this.setPayment()
      await this.setOnHand()
      await this.setConvert()
      await this.setRetur()
      await this.refreshList()
    },
    async setPurchasing () {
      await this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selectedPurchase
      for (let i = 0; i < array.length; i++) {
        await axios.get(purchasingUrl + '/journal/' + array[i], { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Purchasing', error.response.data.message, 'error')
            this.$Progress.finish()
            this.loader.isLoading = false
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.getPurchasing()
    },
    async setSales () {
      await this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selectedSales
      for (let i = 0; i < array.length; i++) {
        await axios.get(salesUrl + '/journal/' + array[i], { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Sales', error.response.data.message, 'error')
            throw error
          })
        await axios.get(salesUrl + '/journal-deliver-cost/' + array[i], { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Sales', error.response.data.message, 'error')
            throw error
          })
        await axios.get(salesUrl + '/journal-stock-out/' + array[i], { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Sales', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      this.getSales()
    },
    async setAdjust () {
      await this.$Progress.start()
      this.loader.isLoading = true
      var url = null
      var array = this.selectedAdjust
      for (let i = 0; i < array.length; i++) {
        const inv = this.adjust.find(d => d.id === array[i])
        if (inv.type_id === 'adjust_decrease') {
          url = inventoryUrl + '/journal-adjust-manufacture-decrease'
        } else if (inv.type_id === 'adjust') {
          url = inventoryUrl + '/journal-adjust-manufacture'
        } else if (inv.type_id === 'adjust_manufacture') {
          url = inventoryUrl + '/journal-adjust-manufacture'
        } else if (inv.type_id === 'adjust_manufacture_decrease') {
          url = inventoryUrl + '/journal-adjust-manufacture-decrease'
        }
        var obj = {
          id: array[i]
        }
        await axios.post(url, obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.getAdjust()
    },
    async setManufacture () {
      await this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selectedManufacture
      var loopMnf = []
      for (let i = 0; i < array.length; i++) {
        await axios.get(manufactureUrl + '/' + array[i], { headers: getHeader() })
          .then(response => {
            var mnf = response.data.data
            var arr = mnf.mproducts
            for (let a = 0; a < arr.length; a++) {
              loopMnf.push(arr[a].id)
            }
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Manufacture', error.response.data.message, 'error')
            throw error
          })
      }
      for (let z = 0; z < loopMnf.length; z++) {
        await axios.post(manufactureUrl + '/mproduct/journal', { id: loopMnf[z] }, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response.data.message)
            this.$swal('Manufacture', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.getManufacture()
    },
    async setCOH () {
      await this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selectedCoh
      for (let i = 0; i < array.length; i++) {
        await axios.post(cohUrl + '/journal-detail/', { id: array[i] }, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Kas', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async setPayment () {
      await this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selectedPayment
      for (let i = 0; i < array.length; i++) {
        var pay = this.payment.find(d => d.id === array[i])
        var type = pay.method_id
        if (pay.category === 'sales') {
          if (type === 4) {
            await axios.post(paymentUrl + '/journal-sales-um', { id: array[i] }, { headers: getHeader() })
              .then(response => {
                console.log(response.data.message)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Payment', error.response.data.message, 'error')
              })
          } else {
            await axios.post(paymentUrl + '/journal-sales', { id: array[i] }, { headers: getHeader() })
              .then(response => {
                console.log(response.data.message)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Payment', error.response.data.message, 'error')
              })
          }
        } else if (pay.category === 'purchasing') {
          if (type === 4) {
            await axios.post(paymentUrl + '/journal-purchasing-um', { id: array[i] }, { headers: getHeader() })
              .then(response => {
                console.log(response.data.message)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Payment', error.response.data.message, 'error')
              })
          } else {
            await axios.post(paymentUrl + '/journal-purchasing', { id: array[i] }, { headers: getHeader() })
              .then(response => {
                console.log(response.data.message)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Payment', error.response.data.message, 'error')
              })
          }
        }
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async setOnHand () {
      await this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selectedOnHand
      for (let i = 0; i < array.length; i++) {
        await axios.post(inventoryUrl + '/on-hand/journal', { id: array[i] }, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.getOnHand()
    },
    async setConvert () {
      await this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selectedConvert
      for (let i = 0; i < array.length; i++) {
        await axios.post(convertUrl + '/journal', { id: array[i] }, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Convert', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.getConvert()
    },
    async setRetur () {
      await this.$Progress.start()
      this.loader.isLoading = true
      var array = this.selectedRetur
      for (let i = 0; i < array.length; i++) {
        const retur = this.retur.find(d => d.id === array[i])
        if (retur.type === 'sales') {
          await axios.post(returnUrl + '/journal-sales/', { id: array[i] }, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Retur', error.response.data.message, 'error')
              throw error
            })
        } else if (retur.type === 'purchasing') {
          console.log(returnUrl + '/journal-purchasing/')
          var body = {
            id: array[i]
          }
          console.log(body)
          await axios.post(returnUrl + '/journal-purchasing/', body, { headers: getHeader() })
            .then(response => {
              console.log(response.data.message)
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Retur', error.response.data.message, 'error')
              throw error
            })
        }
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.getRetur()
    },
    async refreshList () {
      // Start
      await this.$Progress.start()
      this.loader.isLoading = true
      this.selectedPurchase = []
      this.selectedSales = []
      this.selectedManufacture = []
      this.selectedPayment = []
      this.selectedAdjust = []
      this.selectedConvert = []
      this.selectedRetur = []
      this.selectedOnHand = []
      this.selectedCoh = []
      // action
      await this.getPurchasing()
      await this.getSales()
      await this.getManufacture()
      await this.getPayment()
      await this.getAdjust()
      await this.getConvert()
      await this.getRetur()
      await this.getOnHand()
      await this.getCashOnHand()
      // Finish
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async getPurchasing () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = purchasingUrl + '?begin=' + begin + '&end=' + end
      await axios.get(url, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.purchasing = response.data.data
          for (let i = 0; i < this.purchasing.length; i++) {
            if (parseFloat(this.purchasing[i].total_persediaan) === 0) {
              this.selectedPurchase.push(this.purchasing[i].id)
            }
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Purchasing', error.response.data.message, 'error')
        })
    },
    async getSales () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = salesUrl + '?begin=' + begin + '&end=' + end
      await axios.get(url, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.sales = response.data.data
          for (let i = 0; i < this.sales.length; i++) {
            if (parseFloat(this.sales[i].journal_count) <= 0) {
              this.selectedSales.push(this.sales[i].id)
            }
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Purchasing', error.response.data.message, 'error')
        })
    },
    async getManufacture () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = manufactureUrl + '?begin=' + begin + '&end=' + end
      await axios.get(url, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.manufacture = response.data.data
          for (let i = 0; i < this.manufacture.length; i++) {
            if (parseFloat(this.manufacture[i].total_journal) <= 0) {
              this.selectedManufacture.push(this.manufacture[i].id)
            }
          }
        })
    },
    async getPayment () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = paymentUrl + '?begin=' + begin + '&end=' + end
      console.log(url)
      await axios.get(url, { headers: getHeader() })
        .then(response => {
          this.payment = response.data.data
          for (let i = 0; i < this.payment.length; i++) {
            if (parseFloat(this.payment[i].journal_count) === 0) {
              this.selectedPayment.push(this.payment[i].id)
            }
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Payment', error.response.data.message, 'error')
          throw error
        })
    },
    async getAdjust () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = inventoryUrl + '?begin=' + begin + '&end=' + end
      await axios.get(url, { headers: getHeader() })
        .then(response => {
          console.log(response)
          var data = response.data.data
          this.adjust = data.filter(d => d.type_id === 'adjust' || d.type_id === 'adjust_decrease' || d.type_id === 'adjust_manufacture_decrease' || d.type_id === 'adjust_manufacture')
          for (let i = 0; i < this.adjust.length; i++) {
            console.log('adjust total journal')
            const totalJournal = parseFloat(this.adjust[i].total_journal)
            const totalCost = parseFloat(this.adjust[i].total_cost)
            console.log(totalJournal + ' ' + totalCost)
            if (totalJournal !== totalCost) {
              this.selectedAdjust.push(this.adjust[i].id)
            }
          }
        })
    },
    async getConvert () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = convertUrl + '?begin=' + begin + '&end=' + end
      await axios.get(url, { headers: getHeader() })
        .then(response => {
          this.convert = response.data.data
          for (let i = 0; i < this.convert.length; i++) {
            if (parseFloat(this.convert[i].total_journal) === 0) {
              this.selectedConvert.push(this.convert[i].id)
            }
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Convert', error.response.data.message, 'error')
          throw error
        })
    },
    async getRetur () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = returnUrl + '?begin=' + begin + '&end=' + end
      await axios.get(url, { headers: getHeader() })
        .then(response => {
          this.retur = response.data.data
          for (let i = 0; i < this.retur.length; i++) {
            if (this.retur[i].type === 'sales') {
              if (parseFloat(this.retur[i].total_journal) === 0) {
                this.selectedRetur.push(this.retur[i].id)
              }
            } else {
              if (parseFloat(this.retur[i].total_journal_persediaan) === 0) {
                this.selectedRetur.push(this.retur[i].id)
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Retur', error.response.data.message, 'error')
          throw error
        })
    },
    async getOnHand () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var url = inventoryUrl + '/on-hand?begin=' + begin + '&end=' + end
      await axios.get(url, { headers: getHeader() })
        .then(response => {
          this.onHand = response.data.data
          for (let i = 0; i < this.onHand.length; i++) {
            if (parseFloat(this.onHand[i].journal_count) === 0) {
              this.selectedOnHand.push(this.onHand[i].id)
            }
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('On Hand', error.response.data.message, 'error')
          throw error
        })
    },
    async getCashOnHand () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end
      }
      var url = cohUrl + '/detail/list'
      axios.post(url, obj, { headers: getHeader() })
        .then(response => {
          this.coh = response.data.data
          for (let i = 0; i < this.coh.length; i++) {
            if (parseFloat(this.coh[i].total_journal) === 0) {
              this.selectedCoh.push(this.coh[i].id)
            }
          }
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Cash', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>

<style scoped>
.header-period {
  background-color: #6FB56F;
  color: white;
}
.text-ref-sales {
  color: #28A745;
  cursor: pointer;
}
</style>
